<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <new-form />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              FORMULÁRIOS DE SEMIOLOGIA
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'semiology')"
              class="btn-add"
              @click="openNewForm"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-5 col-12 pb-0 pt-0">
            <v-select
              disable-lookup
              label="Status"
              :items="status"
              v-model="query_status"
              @change="getForms"
              outlined
              dense
            />
          </div>
          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-12 pb-0 pt-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="PESQUISAR FORMULÁRIOS DE SEMIOLOGIA"
              outlined
              dense
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="forms.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="forms.length > 0"
          dense
          :search="search"
          :headers="form_headers"
          :items="forms"
          must-sort
          sort-by="name"
          :sort-desc="false"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              v-if="permission('edit', 'semiology')"
              small
              class="btn-edit m-1"
              @click="openForm(item)"
            >
              <i class="fas fa-pencil-alt mr-2 text-twenty" /> EDITAR
            </v-btn>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
          <template v-slot:[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at) }}
          </template>
        </v-data-table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import api from "../services/api";
import { formatDate } from "../lib/format";
import { save, restore, userData } from "../lib/functions";
import permission from "../lib/permission";
import NewForm from "../templates/Semiology/NewForm.vue";
import routes from "../routes";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

export default {
  name: "Semiologies",
  components: {
    NavBar,
    AuthBySessionExpired,
    NewForm,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      loading: false,

      status: [],
      query_status: null,

      search: "",
      form_headers: [
        { text: "Nome", value: "name" },
        { text: "Status", value: "status_name" },
        { text: "Modificado", value: "updated_at" },
        { text: "Criado", value: "created_at" },
        { text: "Ações", value: "actions" },
      ],
      forms: [],
    };
  },
  created() {
    this.permissions = userData().permissions;
    this.retrieve();
  },
  methods: {
    permission,
    formatDate,
    handleToBack: () => routes.go(-1),
    async retrieve() {
      this.permissions = userData().permissions;

      restore(this, "Semiologies");
      await this.getStatus();
      await this.getForms();
    },
    async getStatus() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/semiology/form/status");
        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.status.push({ value: 0, text: "TODOS" });
          // this.query_status = 0;
          for (const s of status) {
            this.status.push({ value: s.id, text: s.name });
            if (s.value == "AVAILABLE") {
              //this.query_status = s.id;
            }
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    saveState() {
      save(this, "Semiologies", ["query_status"]);
    },
    async getForms() {
      try {
        this.loading = true;

        let params = { status: this.query_status };
        let response = await api.get("/rest-home/semiology/forms", { params });
        let { error, errors, forms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.forms = forms;
        }

        this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async openNewForm() {
      this.$bvModal.show("new_semiology_form");
    },
    async openForm(item) {
      this.$router.push({ name: "semiology-form", params: { id: item.id } });
    },
  },
};
</script>

<style></style>
